// import { FileText } from "lucide-react";
// import React from "react";

export const resourceData = [
  {
    id: 15, // Update this ID to whatever sequence number you need
    slug: "agentic-ai-governance",
    type: "Blogs",
    title: "Agentic AI Governance: Lessons from the Hugging Face Breach",
    author: "Harish Malla",
    authorRole: "Cyber Security Consultant",
    date: "September 9, 2026",
    readTime: "12m read",
    category: "AI Security & Governance",
    blogUrl: "/blog/agentic-ai-governance",
    linkText: "Read More",
    imageColor: "from-emerald-950 to-slate-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1788966930/ChatGPT_Image_Sep_9_2026_04_25_42_PM_rnyadu.png",

    // Fallback details for card previews and archive listings
    details: {
      heroTitle: "Agentic AI Governance: Lessons from the Hugging Face Breach",
      introText:
        "An OpenAI evaluation agent broke into Hugging Face’s production systems while every security control in its path allowed it.",
      mainParagraph:
        "A step-by-step post-mortem on how 17,000 individually authorized actions formed a multi-cloud production compromise, and why agent personas, gateway guardrails, and autonomous containment are required to govern autonomous agents.",
      bullets: [
        "How OpenAI's ExploitGym Agent Broke the Hugging Face Sandbox",
        "Why Perimeter Allowlists and Static Auth Failed to Intercept It",
        "Defining Scope via the Machine-Readable Agent Persona",
        "Decoupling Guardrails: Gateway Defense vs. Model-Weight Safety",
        "The Five-Gate Defense Architecture and Machine-Speed Response",
      ],
    },
  },
  {
    id: 14, // Update this ID to whatever number comes next in your list
    slug: "browser-security-blind-spot",
    type: "Blogs",
    title: "The Browser Is Your Biggest Security Blind Spot",
    author: "", // Intentionally left blank as requested
    date: "June 2026",
    readTime: "18m read",
    category: "Browser Security",
    blogUrl: "/blog/browser-security-blind-spot",
    linkText: "Read More",
    imageColor: "from-slate-900 to-emerald-900", // Updated to match the darker, tech-focused theme of the new blog
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1783241813/browser_pkzygn.png",

    // Fallback details just in case it ever renders on a standard card/landing page
    details: {
      heroTitle: "The Browser Is Your Biggest Security Blind Spot",
      introText:
        "95% of enterprises have been hit by browser-based attacks. Yet the browser remains the least governed control point in the enterprise.",
      mainParagraph:
        "This guide explores why the browser has become the highest-risk execution environment, the six key attack vectors every CISO must understand, and how to choose the right browser security architecture.",
      bullets: [
        "Why the Browser is a Prime Target",
        "6 Key Browser Attack Vectors",
        "Comparing Browser Security Architectures",
        "30-Day CISO Security Baseline",
      ],
    },
  },
  {
    id: 13,
    slug: "agentic-ai-digital-workforce-security",
    type: "Whitepaper",

    title:
      "Agentic AI:The New Digital Workforce and the Future of Enterprise Security",

    fileUrl:
      "https://drive.google.com/file/d/1ljwNmOSJ6KGXRD2kg78WIiTSutbwaAHq/view?usp=drive_link",

    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1782404940/add_this_Agentic_AI_The_New_Digital_Workforce_and_the_Future_ox2srg.jpg",

    category: "Agentic AI",

    linkText: "Download Whitepaper",

    imageColor: "from-slate-900 to-blue-900",

    description:
      "As autonomous AI agents gain access to enterprise systems, applications, APIs, and sensitive data, organizations must establish visibility, governance, identity controls, and runtime security to protect against emerging agentic AI threats.",

    details: {
      heroTitle:
        "Agentic AI:The New Digital Workforce and the Future of Enterprise Security",

      introText:
        "Autonomous AI agents are rapidly becoming part of enterprise operations, introducing new security, identity, and governance challenges that traditional security models were never designed to address.",

      mainParagraph:
        "This whitepaper explores the rise of agentic AI, the security risks introduced by autonomous agents, the governance gaps facing enterprises, and the critical controls organizations need to securely operationalize AI agents at scale.",

      bullets: [
        "How agentic AI differs from traditional AI systems",
        "Prompt injection, memory poisoning, and agent impersonation risks",
        "Non-human identity and access management challenges",
        "Runtime behavioral monitoring and governance frameworks",
        "A practical 90-day roadmap for securing AI agents",
      ],
    },
  },
  {
    id: 1,
    slug: "shadow-ai-crisis",
    type: "Whitepaper",
    title:
      "The Shadow AI Crisis: Why Enterprises Are Losing Control of AI Usage",
    fileUrl:
      "https://drive.google.com/file/d/1Z596FHYC49BPWoz8wRLQpSTW_mNIFAQM/view?usp=sharing",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1775970052/High-End_Synthera_Security_Whitepaper_Mockup_gsrwuj.png",
    category: "Shadow AI",

    linkText: "Download Whitepaper",
    imageColor: "from-emerald-900 to-green-900",

    description:
      "73% of employees use unauthorized AI tools, creating hidden risks across enterprise data, systems, and compliance frameworks.",

    details: {
      heroTitle: "The Shadow AI Crisis",
      introText:
        "Uncontrolled AI usage inside enterprises is creating massive unseen risks.",
      mainParagraph:
        "This whitepaper explores how employees are using unauthorized AI tools, exposing sensitive data and bypassing security frameworks.",
      bullets: [
        "What Shadow AI is and why it's dangerous",
        "Data leakage risks from unmanaged AI tools",
        "Governance challenges for enterprises",
        "Strategies to regain control of AI usage",
      ],
    },
  },
  {
    id: 2, // Update this ID to whatever number comes next in your list
    slug: "what-is-privileged-access-management-pam",
    type: "Blogs",
    title: "What Is Privileged Access Management (PAM)?",
    author: "", // Intentionally left blank as requested
    date: "June 4, 2026",
    readTime: "10m read",
    category: "Access Management",
    blogUrl: "/blog/what-is-privileged-access-management-pam",
    linkText: "Read More",
    imageColor: "from-emerald-900 to-teal-900", // Updated to match the PAM blog theme
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1780572932/pam_nsczjo.png", // Intentionally left blank as requested

    // Fallback details just in case it ever renders on a standard card/landing page
    details: {
      heroTitle: "Understanding Privileged Access Management",
      introText:
        "PAM is the control and protection of elevated access rights for privileged accounts within an organization.",
      mainParagraph:
        "This guide explores what privileges are, the types of privileged accounts, the difference between PAM and IAM, and best practices for securing your most critical systems.",
      bullets: [
        "Introduction to PAM & Privileges",
        "Types of Privileged Accounts",
        "Difference Between PAM and IAM",
        "PAM Best Practices & Next Steps",
      ],
    },
  },
  {
    id: 3,
    slug: "ai-guardrails-agentic-ai",
    type: "Whitepaper",

    title: "AI Guardrails: Defining the Boundaries of Autonomous Intelligence",

    fileUrl:
      "https://drive.google.com/file/d/1NncTl0qWcwyuqmk7d5q2yUhcBDQPWPRc/view?usp=sharing",

    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1778574132/ai_guardrails_dojcvh.jpg",

    category: "AI Guardrails",

    linkText: "Download Whitepaper",

    imageColor: "from-slate-900 to-emerald-900",

    description:
      "As autonomous AI agents gain access to enterprise systems, APIs, and sensitive data, organizations need runtime guardrails, governance, and continuous oversight to prevent abuse, data leakage, and AI-driven compromise.",

    details: {
      heroTitle:
        "AI Guardrails: Defining the Boundaries of Autonomous Intelligence",

      introText:
        "Agentic AI introduces a new generation of security risks that traditional controls cannot govern.",

      mainParagraph:
        "This whitepaper explores how AI guardrails, runtime controls, governance frameworks, and layered security architectures help organizations securely operationalize autonomous AI systems at enterprise scale.",

      bullets: [
        "Real-world AI guardrail failures and breaches",
        "Prompt injection and agentic AI attack chains",
        "Runtime controls and behavioral monitoring",
        "Governance frameworks for autonomous AI",
        "Implementation roadmap for AI security maturity",
      ],
    },
  },

  {
    id: 4,
    slug: "securing-agentic-ai",
    type: "Blogs",
    title:
      "Securing Agentic AI: Why Visibility, Behavior, and Guardrails Matter",
    author: "Shoaib Arif",
    date: "March 26, 2026",
    readTime: "5m read",
    category: "AI Security",
    blogUrl: "/blog/securing-agentic-ai",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1775996112/Secure-Autonomous-Agentic-AI-1200x794-1-1024x678.png_lh82ez.webp",

    // ADDED THIS PART TO FIX THE EMPTY SCREEN
    details: {
      heroTitle:
        "Securing Agentic AI: Why Visibility, Behavior, and Guardrails Matter",
      introText:
        "Agentic AI is quickly transitioning from experimentation to production. Enterprises are deploying AI agents to interpret goals and execute actions autonomously.",
      mainParagraph:
        "To secure agentic AI effectively, organizations must address three critical challenges regarding visibility, runtime behavior, and automated guardrails.",
      bullets: [
        "Visibility and Posture – understanding which agents exist",
        "Runtime Behavior – understanding agentic activity at runtime",
        "Guardrails and Controls – detecting and blocking risk behavior",
        "The First Challenge: Unclear Agent Inventory",
      ],
    },

    fullArticle: `
    <p class="text-xl text-gray-600 mb-8 leading-relaxed">Agentic AI is quickly transitioning from experimentation to production. Enterprises are deploying AI agents to interpret goals, decide what actions to take, interact with business tools and APIs, and execute those actions autonomously, with limited or no human oversight.</p>
    
    <p class="mb-6">The promise is speed and efficiency, but the proverbial “blast radius” is bigger and fundamentally different from anything security teams have managed before. Traditional AI security focuses on models and data. Agentic AI introduces something new: autonomous behavior.</p>

    <h2 id="section1" class="text-3xl font-bold text-[#032d28] mt-12 mb-6">The First Challenge: Unclear Agent Inventory and Posture</h2>
    <p class="mb-4">As AI adoption accelerates, agents are being deployed across local environments, managed platforms, and custom-built frameworks. Many organizations lack clear answers to basic questions:</p>
    <ul class="list-disc pl-6 mb-6 space-y-2">
      <li>What agents exist?</li>
      <li>What tools do they invoke?</li>
      <li>What permissions do they have?</li>
      <li>Where is access broader than necessary?</li>
    </ul>

    <h2 id="section2" class="text-3xl font-bold text-[#032d28] mt-12 mb-6">The Second Challenge: Limited Visibility Into Runtime Agent Behavior</h2>
    <p class="mb-4">Configuration alone does not reflect reality. An agent may be approved and properly configured yet behave in unexpected ways once it begins operating.</p>

    <h2 id="section3" class="text-3xl font-bold text-[#032d28] mt-12 mb-6">The Third Challenge – Unsafe Tool Requests and Toxic Agent Flows</h2>
    <p class="mb-6">The most serious risks in Agentic AI arise when agents make unsafe tool requests and create toxic execution flows.</p>

    <h2 id="section4" class="text-3xl font-bold text-[#032d28] mt-12 mb-6">How Synthera AI Security Delivers Value</h2>
    <p class="mb-6">Synthera Agentic AI Security directly addresses these challenges by bringing visibility, control, and consistency to autonomous agents.</p>
  `,
  },

  {
    id: 5,
    slug: "unified-threat-protection",
    type: "Whitepaper",
    title:
      "Unified Threat Protection: From Fragmented Silos to an Integrated Defense Architecture",
    fileUrl:
      "https://drive.google.com/file/d/1m8Z4Y_zv_ZtFi4S2uQF4ippa9t4Lz97N/view?usp=sharing",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776007788/3D_Booklet_Mockup_for_Synthera_Security_nyksnc.png",

    // ✅ FIXED (more accurate category)
    category: "Cybersecurity Architecture",

    linkText: "Download Whitepaper",
    imageColor: "from-green-900 to-teal-950",
    // icon: <FileText className="text-white w-12 h-12 opacity-50" />,

    // ✅ SMALL DESCRIPTION (based on page 2 + 3)
    description:
      "Fragmented security tools create blind spots that attackers exploit. Unified Threat Protection eliminates these gaps with real-time, cross-domain response and machine-speed defense.",

    details: {
      heroTitle: "Unified Threat Protection",

      // ✅ Intro from page 2
      introText:
        "Modern enterprises invest in multiple security tools, yet breaches persist due to lack of integration and contextual visibility across systems.",

      // ✅ Main idea (architecture problem + velocity gap)
      mainParagraph:
        "This whitepaper explains how fragmented security architectures create critical gaps such as contextual blindness and delayed response. It introduces a unified, automated approach that enables real-time threat detection, correlation, and response across identity, endpoint, network, and data layers.",

      // ✅ Key points from multiple pages
      bullets: [
        "Why fragmented security tools create exploitable gaps",
        "Understanding the Velocity Gap between attackers and defenders",
        "How unified telemetry enables real-time threat correlation",
        "Automating response with cross-domain security orchestration",
      ],
    },
  },
  {
    id: 6,
    slug: "autonomous-ai-agents-security",
    type: "Whitepaper",
    title:
      "The Rise of Autonomous AI Agents: Security Risks No One Is Talking About",
    fileUrl:
      "https://drive.google.com/file/d/1_c21QalCD8xTPL3-z1bblnRAG3EuYzkH/view?usp=sharing", // add your PDF link here
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776061830/Synthera_Security_Booklet_Mockup_1_esxdte.png",

    // ADDED THIS PART TO FIX THE EMPTY SCREEN
    category: "AI Security",
    linkText: "Download Whitepaper",
    imageColor: "from-cyan-900 to-blue-900",
    details: {
      heroTitle: "Autonomous AI Agents Security Risks",
      introText:
        "Autonomous AI agents are rapidly being adopted across enterprises, introducing new and largely unmonitored security risks.",
      mainParagraph:
        "This whitepaper explores how AI agents interact with systems, APIs, and data, creating new attack surfaces that traditional security tools are not designed to handle.",
      bullets: [
        "How autonomous agents expand the attack surface",
        "Risks of API access and tool invocation",
        "Lack of visibility into agent behavior",
        "Strategies to secure agent-driven workflows",
      ],
    },
  },
  {
    id: 7,
    slug: "ai-governance-blueprint-enterprise",
    type: "Whitepaper",
    title: "AI Governance Blueprint for the Enterprise",
    fileUrl:
      "https://drive.google.com/file/d/1ajnzkcfCw7uaQRBE7kepNUBqUtuA7Ggi/view?usp=sharing", // add your PDF link here
    category: "AI Governance",
    linkText: "Download Whitepaper",
    imageColor: "from-cyan-900 to-blue-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776092120/Elegant_Cybersecurity_Booklet_Display_cosxez.png",
    // icon: <FileText className="text-white w-12 h-12 opacity-50" />,
    details: {
      heroTitle: "AI Governance Blueprint",
      introText:
        "As AI adoption accelerates, enterprises must establish clear governance frameworks to manage risk, compliance, and operational control.",
      mainParagraph:
        "This whitepaper outlines a structured approach to AI governance, helping organizations define policies, enforce controls, and ensure responsible AI usage across systems, teams, and workflows.",
      bullets: [
        "Building a scalable AI governance framework",
        "Managing risk, compliance, and data security",
        "Establishing policies for AI usage and access",
        "Ensuring accountability and continuous monitoring",
      ],
    },
  },
  {
    id: 8,
    slug: "vercel-breach-ai",
    type: "Blogs",
    title:
      "When Trust Becomes the Attack Surface: Lessons from the Vercel Breach in the Age of AI",
    author: "Akash Sharma",
    date: "April 24, 2026",
    readTime: "6m read",
    category: "AI Security",
    blogUrl: "/blog/vercel-breach-ai",
    linkText: "Read More",
    imageColor: "from-indigo-900 to-purple-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1777029083/Gemini_Generated_Image_ay9ff0ay9ff0ay9f_qcjtgq.png", // You can replace this with a Vercel-specific image later

    // Fallback details just in case it ever renders on a standard card/landing page
    details: {
      heroTitle: "Lessons from the Vercel Breach",
      introText:
        "In modern cloud environments, trust is your largest vulnerability.",
      mainParagraph:
        "This blog explores the Vercel breach, the anatomy of an identity pivot, and why traditional SASE isn't enough to stop AI-accelerated threats.",
      bullets: [
        "The Era of 'Inherited' Access",
        "Anatomy of an Identity Pivot",
        "Identity is the New Perimeter",
        "Building an AI-Aware Architecture",
      ],
    },
  },
  // {
  //   id: 7,
  //   slug: "industrial-iot-security-2025",
  //   type: "Blogs",
  //   title: "2025 State of Industrial IoT Security",
  //   blogUrl: "/blog/solving-ai-fomu",
  //   category: "IoT Security",
  //   linkText: "Read Post",
  //   imageColor: "from-cyan-900 to-blue-900",
  //   icon: <FileText className="text-white w-12 h-12 opacity-50" />,
  //   details: {
  //     heroTitle: "2025 State of Industrial IoT Security",
  //     introText:
  //       "The rapid growth of IIoT has expanded the attack surface for enterprises.",
  //     mainParagraph:
  //       "This report highlights key vulnerabilities, threats, and strategies to secure industrial environments.",
  //     bullets: [
  //       "Top IIoT vulnerabilities",
  //       "Emerging ransomware trends",
  //       "IT/OT security challenges",
  //       "Best practices for industrial security",
  //     ],
  //   },
  // },
  {
    id: 9,
    slug: "sase-ai-control-plane",
    type: "Whitepaper",
    title: "SASE in the Age of Artificial Intelligence",
    category: "AI Security",
    fileUrl:
      "https://drive.google.com/file/d/1QtvwZuE1onOl1ZFGMmkNVr0GCP2uTXIR/view?usp=sharing",
    linkText: "Download Whitepaper",
    imageColor: "from-emerald-900 to-teal-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1777308368/_eb2fd86e-0d6f-436a-86b6-3f20fdd37a0b_opag89.jpg",

    details: {
      heroTitle: "SASE in the Age of Artificial Intelligence",

      introText:
        "Artificial Intelligence is transforming enterprise environments, introducing autonomous systems that operate across applications, APIs, and distributed infrastructures.",

      mainParagraph:
        "This whitepaper explores how Secure Access Service Edge (SASE) provides a unified, identity-centric control plane to secure AI-driven interactions, enabling organizations to maintain visibility, enforce policy, and protect data across evolving AI ecosystems.",

      bullets: [
        "Understanding SASE as a unified networking and security model",
        "How AI introduces new risks across agents, APIs, and workflows",
        "Applying zero-trust principles to AI-driven systems",
        "Real-time visibility and policy enforcement for AI interactions",
        "Building a scalable and secure foundation for autonomous AI",
      ],
    },
  },

  // {
  //   id: 10,
  //   slug: "quantum-decryption-defense",
  //   type: "Whitepaper",
  //   title: "Defending Against Quantum Decryption",
  //   category: "Encryption",
  //   linkText: "Read Whitepaper",
  //   imageColor: "from-green-950 to-gray-900",
  //   icon: <FileText className="text-white w-12 h-12 opacity-50" />,
  //   details: {
  //     heroTitle: "Defending Against Quantum Decryption",
  //     introText:
  //       "Quantum computing threatens to break modern encryption systems.",
  //     mainParagraph:
  //       "This whitepaper explains how organizations can prepare for quantum threats using post-quantum cryptography.",
  //     bullets: [
  //       "Understanding quantum threats",
  //       "Post-quantum cryptography basics",
  //       "Migration strategies",
  //       "Future-proofing encryption systems",
  //     ],
  //   },
  // },
  {
    id: 11, // Incrementing the ID
    slug: "perfect-hack-boardroom-strategy",
    type: "Blogs",
    title:
      "The Mythos of the 'Perfect Hack': Why Your Boardroom Strategy Just Became Obsolete",
    author: "Harish Malla",
    date: "May 1, 2026",
    readTime: "10m read",
    category: "Cyber Strategy",
    blogUrl: "/blog/perfect-hack-boardroom-strategy",
    linkText: "Read More",
    imageColor: "from-slate-900 to-emerald-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1777649809/perfect_hack_zvrhrv.png",

    // Fallback details for cards or landing page sections
    details: {
      heroTitle: "The Mythos of the 'Perfect Hack'",
      introText:
        "AI hasn't created new vulnerabilities; it just found the flashlight to expose the ones we've ignored for years.",
      mainParagraph:
        "A deep dive into why traditional risk math is dead, the emergence of 'Claude Mythos' as a threat vector, and how leadership must pivot to survival-based security.",
      bullets: [
        "The Era of 'Automated' Exploitation",
        "Why the Cost of Infiltration has Flatlined",
        "The Legacy Trap in OT Environments",
        "Building a Dedicated AI Threat War Room",
      ],
    },
  },
  {
    id: 12, // Incrementing the ID
    slug: "ztna-vs-vpn-future-of-secure-access",
    type: "Blogs",
    title: "ZTNA vs VPN: Why Zero Trust Is the Future of Secure Access",
    author: "Bineesh P",
    date: "June 10, 2026",
    readTime: "6m read",
    category: "Network Security",
    blogUrl: "/blog/ztna-vs-vpn-future-of-secure-access",
    linkText: "Read More",
    imageColor: "from-emerald-600 to-teal-900",
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1780996162/ChatGPT_Image_Jun_9_2026_02_38_26_PM_rcqinr.png",

    // Fallback details for cards or landing page sections
    details: {
      heroTitle: "ZTNA vs VPN: The Future of Secure Access",
      introText:
        "Traditional tools like Virtual Private Networks (VPNs), which once stood as the gold standard of secure connectivity, are now showing their age. Enter Zero Trust.",
      mainParagraph:
        "A critical comparison in today’s hyperconnected world, exploring why Zero Trust Network Access (ZTNA) is an identity-centric approach rapidly replacing VPNs in forward-thinking organizations.",
      bullets: [
        "The Rise and Fall of Traditional VPNs",
        "Understanding Zero Trust Network Access (ZTNA)",
        "Key Differences Between ZTNA and VPN",
        "Adaptive Access and Minimizing the Attack Surface",
      ],
    },
  },
];
